import { combineReducers } from 'redux'
import addProductsServiceReducer from '../../containers/AddProductsServices/AddProductsServices.reducer'
import authorizationProviderReducer from '../../containers/AuthorizationProvider/AuthorizationProvider.reducer'
import cancelBidSellerDialogReducer from '../../containers/CancelBidSellerDialog/CancelBidSellerDialog.reducer'
import cancelQuoteDialogReducer from '../../containers/CancelQuoteDialog/CancelQuoteDialog.reducer'
import configProviderReducer from '../../containers/ConfigProvider/ConfigProvider.reducer'
import declarationInadmissibilityQuoteDialogReducer from '../../containers/QuoteDeclarationInadmissibilityDialog/QuoteDeclarationInadmissibilityDialog.reducer'
import extendQuoteClosingDateDialogReducer from '../../containers/ExtendQuoteClosingDateDialog/ExtendQuoteClosingDateDialog.reducer'
import onboardingDialogReducer from '../../containers/OnboardingDialog/OnboardingDialog.reducer'
import publishQuoteDialogReducer from '../../containers/PublishQuoteDialog/PublishQuoteDialog.reducer'
import purchaseOrderChangeStatusDialogReducer from '../../containers/PurchaseOrderChangeStatusDialog/PurchaseOrderChangeStatusDialog.reducer'
import purchaseOrderStatusReducer from '../../containers/PurchaseOrderStatus/PurchaseOrderStatus.reducer'
import quoteBasicInformationReducer from '../../containers/QuoteBasicInformation/QuoteBasicInformation.reducer'
import quoteBidReducer from '../../containers/QuoteBid/QuoteBid.reducer'
import quoteBidSeeDetailDialogReducer from '../../containers/QuoteBidSeeDetailDialog/QuoteBidSeeDetailDialog.reducer'
import quoteBidSellerReducer from '../../containers/QuoteBidSeller/QuoteBidSeller.reducer'
import quoteProvidersListReducer from '../../containers/QuoteProvidersList/QuoteProvidersList.reducer'
import quoteRequestPublishedErrorDialogReducer from '../../containers/QuoteRequestPublishedErrorDialog/QuoteRequestPublishedErrorDialog.reducer'
import quoteStepOneReducer from '../../containers/QuoteStepOne/QuoteStepOne.reducer'
import quoteStepTwoReducer from '../../containers/QuoteStepTwo/QuoteStepTwo.reducer'
import quoteRecordsDialogReducer from '../../containers/QuoteRecordsDialog/QuoteRecordsDialog.reducer'
import quoteSearchFiltersReducer from '../../containers/QuoteSearchFilters/QuoteSearchFilters.reducer'
import quoteSearchHeadingFiltersStateReducer from '../../containers/QuoteSearchHeadingFilter/QuoteSearchHeadingFilters.reducer'
import quoteSearchResultsReducer from '../../containers/QuoteSearchResults/QuoteSearchResults.reducer'
import searchGoodsAndServicesByCategoryReducer from '../../containers/SearchGoodsAndServicesByCategory/SearchGoodsAndServicesByCategory.reducer'
import sendSellerQuoteDialogReducer from '../../containers/SendSellerQuoteDialog/SendSellerQuoteDialog.reducer'
import selectOfferDialogReducer from '../../containers/SelectOfferDialog/SelectOfferDialog.reducer'
import declarationDesertedyQuoteDialogReducer from '../../containers/QuoteDeclarationDesertedDialog/QuoteDeclarationDesertedDialog.reducer'
import forcedEMTDialogReducer from '../../containers/ForcedEMTDialog/ForcedEMTDialog.reducer'

export default combineReducers({
  addProductsService: addProductsServiceReducer,
  authorizationProvider: authorizationProviderReducer,
  cancelBidSellerDialog: cancelBidSellerDialogReducer,
  cancelQuoteDialog: cancelQuoteDialogReducer,
  configProvider: configProviderReducer,
  declarationDesertedyQuoteDialog: declarationDesertedyQuoteDialogReducer,
  declarationInadmissibilityQuoteDialog: declarationInadmissibilityQuoteDialogReducer,
  extendQuoteClosingDateDialog: extendQuoteClosingDateDialogReducer,
  onboardingDialog: onboardingDialogReducer,
  publishQuoteDialog: publishQuoteDialogReducer,
  purchaseOrderChangeStatusDialog: purchaseOrderChangeStatusDialogReducer,
  purchaseOrderStatus: purchaseOrderStatusReducer,
  quoteBasicInformation: quoteBasicInformationReducer,
  quoteBid: quoteBidReducer,
  quoteBidSeeDetailDialog: quoteBidSeeDetailDialogReducer,
  quoteBidSeller: quoteBidSellerReducer,
  quoteProvidersList: quoteProvidersListReducer,
  quoteRequestPublishedErrorDialog: quoteRequestPublishedErrorDialogReducer,
  quoteStepOne: quoteStepOneReducer,
  quoteStepTwo: quoteStepTwoReducer,
  quoteRecordsDialog: quoteRecordsDialogReducer,
  quoteSearchHeadingFilters: quoteSearchHeadingFiltersStateReducer,
  quoteSearchFilters: quoteSearchFiltersReducer,
  quoteSearchResults: quoteSearchResultsReducer,
  searchGoodsAndServicesByCategory: searchGoodsAndServicesByCategoryReducer,
  sendSellerQuoteDialog: sendSellerQuoteDialogReducer,
  selectOfferDialog: selectOfferDialogReducer,
  forcedEMTDialog: forcedEMTDialogReducer
})
